import * as types from "../../ActionType";

const initState = {
    products: [],
    loadingProducts: true,
    one_product: {},
    loadingOneProduct: true,
    productsByZone: [],
    loadingProductsByZone: true
}

const ProductsReducer = (state = initState, action) => {
    switch (action.type) {
        case types.ADD_PRODUCT:
            return { ...state, loadingProducts: true }
        case types.GET_PRODUCTS:
            return { ...state, products: action.payload, loadingProducts: false }
        case types.GET_PRODUCTS_BY_ZONE:
            return { ...state, productsByZone: action.payload, loadingProductsByZone: false }
        case types.EMPTY_PRODUCTS_BY_ZONE:
            return { ...state, productsByZone: action.payload, loadingProductsByZone: true }
        case types.GET_ONE_PRODUCT:
            return { ...state, one_product: action.payload, loadingOneProduct: false }
        case types.EMPTY_ONE_PRODUCT:
            return { ...state, one_product: action.payload, loadingOneProduct: true }
        case types.DELETE_PRODUCT:
            return { ...state }
        case types.EDIT_PRODUCT:
            return { ...state, loadingProducts: true }
        case types.ASSIGN_PRODUCT_TO_ZONE:
            return { ...state, loadingProductsByZone: true }
        default:
            return state;
    }
};

export default ProductsReducer;
